module.exports = __webpack_public_path__ + "img/LoanOffers.cd9ae7bc.svg";